export type { LoginPayload, LoginResponse, UserSession } from "@airange/shared/index-airange-admin";

import {
  canAccessAirangeAdminPlatform,
  canAccessAssetCenter,
  canAccessBusinessReferenceCenter,
  canAccessCapabilityGraphCenter,
  canAccessEnvironmentCenter,
  canAccessExecutionCenter,
  canAccessIdentityCenter,
  canAccessIntelligenceCenter,
  canAccessTacticsTechniquesCenter,
  canAccessTrafficLibraryCenter,
  canAccessVulnerabilityLibraryCenter,
  type UserSession,
} from "@airange/shared/index-airange-admin";

export function readAdminPlatformRoles(user: { platform_roles?: string[] | null }) {
  if (user.platform_roles === null || user.platform_roles === undefined) {
    throw new Error("CONTRACT_MISSING:user.platform_roles");
  }
  if (!Array.isArray(user.platform_roles)) {
    throw new Error("CONTRACT_INVALID:user.platform_roles");
  }
  return user.platform_roles;
}

export function canViewPlatformDashboard(user: Pick<UserSession, "is_superuser" | "platform_roles"> | null | undefined) {
  if (!user) {
    return false;
  }
  if (user.is_superuser) {
    return true;
  }
  return readAdminPlatformRoles(user).includes("platform_admin");
}

export function canManagePlatform(user: Pick<UserSession, "is_superuser" | "platform_roles"> | null | undefined) {
  return canAccessAirangeAdminPlatform(user);
}

export function resolveAdminDefaultPath(user: Pick<UserSession, "is_superuser" | "platform_roles"> | null | undefined) {
  if (canViewPlatformDashboard(user)) {
    return "/dashboard";
  }
  if (canAccessIdentityCenter(user)) {
    return "/identity/dashboard";
  }
  if (canAccessAssetCenter(user)) {
    return "/assets-center/dashboard";
  }
  if (canAccessEnvironmentCenter(user)) {
    return "/environment-center/dashboard";
  }
  if (canAccessExecutionCenter(user)) {
    return "/execution-center/dashboard";
  }
  if (canAccessIntelligenceCenter(user)) {
    return "/intelligence-center/dashboard";
  }
  if (canAccessCapabilityGraphCenter(user)) {
    return "/capability-graph/dashboard";
  }
  if (canAccessTacticsTechniquesCenter(user)) {
    return "/tactics-techniques-hub/dashboard";
  }
  if (canAccessVulnerabilityLibraryCenter(user)) {
    return "/vulnerability-library/dashboard";
  }
  if (canAccessBusinessReferenceCenter(user)) {
    return "/business-reference-center/dashboard";
  }
  if (canAccessTrafficLibraryCenter(user)) {
    return "/traffic-library/packet-files";
  }
  if (canManagePlatform(user)) {
    return "/centers";
  }
  return "/dashboard";
}
